import * as React from "react";
import * as questionIds from "@teamprevent/common/questionnaires/questionnaireConfig/genericCase/questionIds";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { QuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { LinkObject } from "@teamprevent/common/model";

interface Props {
    questionConfigs: QuestionConfig[];
    genericCaseTypes: LinkObject[];
    readonly: boolean;
}

export const OtherServicesSection: React.FunctionComponent<Props> = ({ questionConfigs, genericCaseTypes, readonly }) => {
    const genericCaseTypeOptions = React.useMemo(() => {
        return genericCaseTypes?.map(gct => ({ text: gct.name, value: gct.id })).sort((a, b) => a.text.localeCompare(b.text));
    }, [genericCaseTypes]);

    return (
        <ContextAwareProgressBarQuestionnaireSection title="Other Services" id="OtherServices">
            <DropdownQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.ServiceRequired)}
                options={genericCaseTypeOptions}
                readonly={readonly}
                mandatory={true}
            />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
